import {CSSProperties, SVGProps} from "react";
import {omit} from "lodash";

export interface LogoProps extends SVGProps<SVGSVGElement> {
    color?: string;
    color2?: string;
}
export const LogoSVG = (props:LogoProps) => {
    const color = props.color ? props.color.toLowerCase() : '#fff';
    const color2 = props.color2 ? props.color2.toLowerCase() : (() => {
        if (color == '#adcaff') return '#78a7ff';
        if (color == '#f5f8ff') return '#e2ecff';
        if (color == '#e2ecff') return '#adcaff';
        if (color == '#fff' || color == '#ffffff') return '#e2ecff';
        if (color == '#6a739a') return '#081757';
        return color;
    })();

    const textStyle: CSSProperties = {
        fontFamily: 'Fabada',
        fontSize: '2px',
        wordSpacing: '0px',
        fill: 'url(#lcGrad)',
        stroke: 'url(#lcGrad)',
        whiteSpace: 'pre'
    };

    const learningStyle = {
        fontWeight: 400,
        fontSize: '104px',
        strokeWidth: '3px'
    }
    const cloudStyle = {
        fontWeight: 400,
        fontSize: '102px',
        strokeWidth: '0px',
        fill: color
    }

    return (<svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1024 129.43"
            {...omit(props, ['color', 'color2'])}
        >
            <title>Learning Cloud</title>
            <style>{"@import url(https://fonts.cdnfonts.com/css/fabada);"}</style>
            <linearGradient id="lcGrad" x1="0" y1="0" x2="90%" y2="100%" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor={color}></stop>
                <stop offset="1" stopColor={color2}></stop>
            </linearGradient>
            <path style={{fill: 'url(#lcGrad);'}}
                  d="M 114.779 98.848 C 133.579 95.968 147.889 81.308 147.889 63.648 C 147.889 46.958 135.109 32.928 117.829 29.018 C 112.469 12.908 95.809 1.168 76.089 1.168 C 52.779 1.168 33.749 17.558 32.569 38.188 C 14.689 39.178 0.519 52.478 0.519 68.748 C 0.519 83.748 12.559 96.218 28.449 98.848 L 114.779 98.848 Z"></path>
            <text transform="translate(160 100)" style={textStyle}>
                <tspan style={learningStyle}>learning</tspan>
                <tspan style={cloudStyle}>cloud</tspan>
            </text>
        </svg>
    );

}
